export enum DynamicSelectorTabs {
  YearMakeModal = 'YearMakeModal',
  VIN = 'VIN',
  LicensePlateTab = 'LicensePlateTab',
}
